export default __webpack_public_path__ + "static/media/IMG5.a7d27edc.jpg";